export async function clientNotesGetByClientId(clientId: string) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/client-notes/${clientId}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
  return response.json()
}

/**
 * One request that returns every client id that has at least one note, so the
 * client list can render the notes badge without a call per row.
 */
export async function clientNotesSummary(): Promise<{ ok: boolean; clientIds: string[] }> {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/client-notes/summary`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
  return response.json()
}

export async function clientNoteCreate(clientId: string, text: string) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/client-notes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clientId, text }),
  })
  return response.json()
}

export async function clientNoteDelete(id: string) {
  const response = await fetch(`${process.env.REACT_APP_API_URL}/client-notes/${id}`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
  })
  return response.json()
}
